var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"amount"},[(_vm.currency)?_c('span',[_vm._v(_vm._s(_vm.symbol))]):_vm._e(),_c('span',{ref:"textRef"},[_vm._v(_vm._s(_vm.value || _vm.value == "0" ? _vm.value.toFixed(2) : ""))]),(_vm.suffix)?_c('span',{staticStyle:{"margin-right":"3px"}},[_vm._v(_vm._s(_vm.suffix))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }